import deleteProduct from './deleteProduct'

export default deleteProduct
